/**
 * Returns the (dx, dy) that corrects a point computed via getScreenCTM into
 * true viewport coordinates.
 *
 * getScreenCTM walks the SVG ancestor chain only — it ignores CSS transforms
 * on HTML ancestors of the <svg> root. In Oscilla the score is scrolled by
 * setting `transform: translateX(...)` on the HTML #scrollStage wrapper, so
 * any CTM-based screen position is off by that translate amount.
 *
 * The fix: compare where getScreenCTM thinks the SVG root is (ctm.e/.f) with
 * where it actually renders (getBoundingClientRect) and use the delta to
 * correct any CTM-derived viewport coordinate.
 */
export function screenSpaceDelta(svg) {
    if (!svg) return { dx: 0, dy: 0 };
    const rect = svg.getBoundingClientRect();
    const ctm = svg.getScreenCTM();
    if (!ctm) return { dx: 0, dy: 0 };
    return { dx: rect.left - ctm.e, dy: rect.top - ctm.f };
}
